import MembershipUnitsModule from "./membershipUnitsModule";
import MembershipUnitsSagas from "./redux/membershipUnitsSagas";
import MembershipUnitsReducer from "./redux/membershipUnitsReducer";

export default {
  Component: MembershipUnitsModule,
  moduleName: "membershipUnits",
  saga: MembershipUnitsSagas(),
  reducer: MembershipUnitsReducer
};
